import { Heart, Mail, Globe, Phone, Calendar, Download } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white py-12 px-6 border-t border-white/5" data-testid="footer">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Columna 1: Información */}
          <div>
            <h3 className="gotham-bold text-xl mb-4 bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">
              ViubuxConnect
            </h3>
            <p className="verdana-regular text-white/70 text-sm mb-4">
              El ecosistema para conectar mentes brillantes: autores, creadores y audiencias.
            </p>
            <div className="flex items-center gap-2 text-white/60 text-sm verdana-regular">
              <Heart className="w-4 h-4" style={{ color: '#7012b2' }} />
              <span>Hecho con Amor por Viubux Media</span>
            </div>
          </div>

          {/* Columna 2: Contacto */}
          <div>
            <h3 className="gotham-bold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3 verdana-regular text-sm">
              <li>
                <a 
                  href="tel:+525548564696" 
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-phone"
                >
                  <Phone className="w-4 h-4" />
                  +52 55 4856 4696
                </a>
              </li>
              <li>
                <a 
                  href="mailto:email@viubux.com" 
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-email"
                >
                  <Mail className="w-4 h-4" />
                  email@viubux.com
                </a>
              </li>
              <li className="pt-2">
                <p className="text-white/80 mb-2 gotham-medium">Agenda una Reunión</p>
                <a 
                  href="https://vbx.viubux.com/agenda" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-agenda"
                >
                  <Calendar className="w-4 h-4" />
                  Agenda Virtual
                </a>
              </li>
              <li>
                <p className="text-white/80 mb-2 gotham-medium">Guarda nuestro contacto</p>
                <a 
                  href="https://vbx.viubux.com/vcard" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-vcard"
                >
                  <Download className="w-4 h-4" />
                  Descargar VCard
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 3: Links */}
          <div>
            <h3 className="gotham-bold text-lg mb-4">Enlaces Oficiales</h3>
            <ul className="space-y-2 verdana-regular text-sm">
              <li>
                <a 
                  href="https://www.viubux.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-viubux"
                >
                  <Globe className="w-4 h-4" />
                  Viubux.com
                </a>
              </li>
              <li>
                <a 
                  href="https://connect.viubux.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-connect"
                >
                  <Globe className="w-4 h-4" />
                  Connect.Viubux.com
                </a>
              </li>
              <li>
                <a 
                  href="https://play.viubux.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-play"
                >
                  <Globe className="w-4 h-4" />
                  Play.Viubux.com
                </a>
              </li>
              <li>
                <a 
                  href="https://reader.viubux.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-reader"
                >
                  <Globe className="w-4 h-4" />
                  Reader.Viubux.com
                </a>
              </li>
              <li>
                <a 
                  href="https://app.viubux.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors flex items-center gap-2"
                  data-testid="link-app"
                >
                  <Globe className="w-4 h-4" />
                  App.Viubux.com
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 4: Creadores */}
          <div>
            <h3 className="gotham-bold text-lg mb-4">¿Eres Creador de Contenido / Autor?</h3>
            <p className="verdana-regular text-white/70 text-sm mb-4">
              Produce y Distribuye con nosotros
            </p>
            <a
              href="https://cotizaciones.viubux.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 rounded-lg text-white gotham-medium text-sm transition-all hover:scale-105"
              style={{ background: 'linear-gradient(135deg, #7012b2, #662d91)' }}
              data-testid="link-cotizaciones"
            >
              Cotiza Ahora
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-6 text-center">
          <p className="verdana-regular text-white/60 text-sm">
            Copyright © 2026-2030 Viubux Media. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
